import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { browserHistory, Router } from 'react-router';
import { HttpCode } from './enums/HttpCode';
import { setCurrentUser } from './redux/actions/index';
import Routes from "./Routes";
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";
import { Config, TokenManager, UserManager, FRUser } from '@forgerock/javascript-sdk';
import SessionTimeoutManager from './components/Shared/SessionTimeoutManager';
import { getEnvironmentFromHost, getClientIdFromHostname, createUser, updateUser } from './utils/UserUtils';
import { getFreshTokens, getExpirySeconds } from './utils/TokenUtils';
import Spinner from '../src/components/Shared/Spinner';
import { RENEW_BUFFER_SEC } from './constants/SessionTimer'
import { refreshAccessToken } from './services/authService';

const env = location.host.toLowerCase();
const environment = getEnvironmentFromHost().toUpperCase();

const hostname = window.location?.hostname;
const clientId = getClientIdFromHostname(hostname, environment);
console.log(hostname, '[cfg] Env:-', environment.toUpperCase(), 'client:-', clientId);

Config.set({
  serverConfig: {
    baseUrl: process.env[`REACT_APP_${environment.toUpperCase()}_IAM_URL`],
    timeout: parseFloat(process.env.REACT_APP_TIMEOUT ?? "5000"),
  },
  realmPath: process.env[`REACT_APP_${environment.toUpperCase()}_REALM_PATH`],
  clientId: clientId,
  redirectUri: window.location.origin + process.env[`REACT_APP_${environment.toUpperCase()}_REDIRECT_URI`],
  scope: 'openid profile',
  
});

function mapDispatchToProps(dispatch) {
  return ({
    setCurrentUser: currentUser => dispatch(setCurrentUser(currentUser)),
  });
}

var reactPlugin = new ReactPlugin();

var key = "";
if (env.indexOf("localhost") > -1 || env.indexOf("qa") > -1)
  key = '7058fe84-a0ee-41af-a74d-5faae58ff504';
else if (env.indexOf("int") > -1)
  key = '3a256e61-e743-4f7a-966d-5786f7b77646';
else if (env.indexOf("stg") > -1)
  key = '6ce2b288-dbc1-48ce-b4f2-b2e4988b411c';
else if (env.indexOf("perf") > -1)
  key = 'f122e474-26e2-4c89-94ce-b4f5d2354064';
else if (env.indexOf("csb") > -1)
  key = 'd40f48c6-1326-4247-bb5e-a65da18b858a';
else
  key = '18c0408f-d92e-4143-843f-ef221ee14caf';


var appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: key,     //use localstorage.environment? 
    enableAutoRouteTracking: true,
    disableAjaxTracking: false,
    disableCorrelationHeaders: false,
    disableFetchTracking: false,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableCorsCorrelation: false,
    extensions: [reactPlugin],
  }
});
appInsights.loadAppInsights();

axios.interceptors.request.use(async (config) => {

  // Always going SDK for tokens; it returns cached ones unless near expiry (threshold)
  // const tokens = await TokenManager.getTokens({ oauthThreshold: RENEW_BUFFER_SEC });
  const tokens = await TokenManager.getTokens();

  if (tokens?.accessToken) {
    config.headers.common['token'] = `${tokens.idToken}`;
    config.headers.common['User-Id'] = localStorage.getItem("userID") ?? undefined;

  }

  //build fully-qualified request url. ignore paths beginning with http.
  if (config.url.indexOf("http") === -1) {
    if (process.env.NODE_ENV === 'development') {
      //memberService API calls
      if (config.url.search("/memberService/v1") === 0) {
        config.url = process.env.REACT_APP_MEMBER_API_URL_DEV + '/' + localStorage.getItem('lineOfBusiness') + config.url.replace('/memberService/v1', '');
      }
      //NLP API calls
      else if (config.url.search("/mrrnlpapi/v1") === 0) {
        var baseUrl = '';
        if (localStorage.Environment === 'prod')
          baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_PROD
        else if (localStorage.Environment === 'int')
          baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_INT;
        else if (localStorage.Environment === 'stg' || localStorage.Environment === 'stage')
            baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_INT;
        else if (localStorage.Environment === 'perf')
            baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_PERF;
        else if (localStorage.Environment === 'qa')
          baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_QA;
        else
          baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_DEV;

        // var client = localStorage.Client === null || localStorage.Client === undefined ? 'qa' : localStorage.Client;
        var client = sessionStorage.getItem("Client") === null || sessionStorage.getItem("Client") === undefined ? 'qa' : sessionStorage.getItem("Client");
        config.url = baseUrl + '/' + client + '/' + sessionStorage.getItem('lineOfBusiness').toLowerCase() + config.url.replace('/mrrnlpapi/v1', '');
        console.log("mrr-nlp-api url"); console.log(config.url);
      }
      //MRR Service API calls
      else {
        config.url = process.env.REACT_APP_MRR_API_URL_DEV + '/' + sessionStorage.getItem('lineOfBusiness') + config.url.replace('/mrrService/v1', '');
      }
    }
    //Non Dev Environments
    else {
      if (config.url.search("/memberService/v1") === 0) {
        console.log("memberService URI");
        config.url = process.env.REACT_APP_MEMBER_API_URL_PROD + '/' + sessionStorage.getItem('lineOfBusiness') + config.url.replace('/memberService/v1', '');
      }
      else if (config.url.search("/mrrnlpapi/v1") === 0) {
        var baseUrl = '';
        if (localStorage.Environment === 'prod')
          baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_PROD
        else if (localStorage.Environment === 'int')
          baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_INT;
        else if (localStorage.Environment === 'stg' || localStorage.Environment === 'stage')
          baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_INT;
        else if (localStorage.Environment === 'qa')
          baseUrl = process.env.REACT_APP_MRR_NLP_API_URL_QA;

        var client = sessionStorage.getItem("Client");
        config.url = baseUrl + '/' + client + '/' + sessionStorage.getItem('lineOfBusiness').toLowerCase() + config.url.replace('/mrrnlpapi/v1', '');
        console.log("mrr-nlp-api url"); console.log(config.url);
      }
      else {
        console.log("mrrService URI");
        config.url = process.env.REACT_APP_MRR_API_URL_PROD + '/' + sessionStorage.getItem('lineOfBusiness') + config.url.replace('/mrrService/v1', '');
      }
    }
  }

  return config;
});


axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;

    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        // Force a renew (uses refresh token if present)
        // const t = await TokenManager.getTokens({ forceRenew: true });
        const t = await TokenManager.getTokens();

        if (t?.accessToken) {
          if (!original.headers) original.headers = {};
          original.headers['token'] = `${t.idToken}`;
          return axios(original); // retry once

        }
      } catch {
        // fall through to logout below
      }
    }

    // If still unauthorized, clear session
    if (error.response?.status === 401) {
      try {
        await FRUser.logout();                      // server-side + SDK logout
      } finally {
        await TokenManager.deleteTokens();          // clear local tokens
        window.location.href = "/Unauthorized";
      }
    }

    return Promise.reject(error);
  }
);


class App extends React.Component {
  state = { hydrated: false };
  renewTimer = null;
  _isHydrating = false;

  _visibilityHandler = async () => {
    if (document.visibilityState === 'visible') {
      await getFreshTokens();
    }
  };

  setRenewing = (value) => {
    // this.setState({ isRenewing: value });
    // Persist across remounts in same tab
    if (value) {
      sessionStorage.setItem('auth:isRenewing', '1');
    } else {
      sessionStorage.removeItem('auth:isRenewing');
    }
  };

  clearRenewTimer() {
    if (this.renewTimer) {
      clearTimeout(this.renewTimer);
      this.renewTimer = null;
    }
  }

  /**
* Schedules a silent token renewal `bufferSec` seconds before expiry.
* @param {object} tokens  - token object returned by TokenManager
* @param {number} bufferSec - how many seconds before expiry to renew (default 5 min)
*/
  scheduleProactiveRenew(tokens, bufferSec = RENEW_BUFFER_SEC) {
    this.clearRenewTimer();

    const expiryEpochSec = getExpirySeconds(tokens); // absolute epoch seconds
    if (!expiryEpochSec) {
      console.warn('[Auth] Cannot schedule renewal — no expiry found in tokens');
      return;
    }

    const nowSec = Math.floor(Date.now() / 1000);
    const secondsUntilRenew = expiryEpochSec - bufferSec - nowSec;

    // If already within buffer window (or past expiry), renew immediately
    const waitMs = Math.max(secondsUntilRenew * 1000, 0);

    console.log(
      `[Auth] Token expires in ${expiryEpochSec - nowSec}s. ` +
      `Scheduling renewal in ${Math.round(waitMs / 1000)}s (buffer=${bufferSec}s)`
    );
    // refreshAccessToken();
    this.renewTimer = window.setTimeout(async () => {
      console.log('[Auth] Proactive renewal triggered');
      this.setRenewing(true);
      try {
        // Use oauthThreshold (not forceRenew) so SDK uses refresh token gracefully
        const renewed =  await refreshAccessToken()
        console.log('[Renew] Forcing token renewal via refresh token…');

        if (renewed?.accessToken) {
          console.log('[Auth] Token renewed successfully');
          // Verify new expiry is actually in the future before rescheduling
          const newExpiry = getExpirySeconds(renewed);
          const newWait = newExpiry - bufferSec - Math.floor(Date.now() / 1000);
          console.log('[Auth] New token expiry:', new Date(newExpiry * 1000).toLocaleString());
          console.log('[Auth] Next renewal in:', Math.round(newWait / 60), 'minutes');
          this.scheduleProactiveRenew(renewed,bufferSec)
        } else {
          console.warn('[Auth] Renewal returned no tokens — user may need to re-login');
        }
      } catch (err) {
        console.error('[Auth] Proactive renewal failed:', err);
      } finally {
        this.setRenewing(false);
      }
    }, waitMs);
  }


  authHydrate = async (authAction, tokensOptions) => {
    // Guard — prevent concurrent calls
    if (this._isHydrating) {
      console.warn('[Auth] authHydrate already in progress — skipping');
      return;
    }
    this._isHydrating = true;
    try {
      await TokenManager.getTokens(tokensOptions)
        .then(async (tkns) => {
          // Get user info (your code uses UserManager; use your wrapper if needed)
          const user = await UserManager.getCurrentUser();
          localStorage.setItem("username", user.name);
          localStorage.setItem("useremail", user.email);
          // saveTokens(tkns)


          //  user/role logic ...
          const parsedUser = createUser(user);
          updateUser(parsedUser);
          this.setState({ hydrated: true });

          //sufficient role check
          if (!parsedUser || !parsedUser.clientLobRoles) return;

          const clientNames = Object.keys(parsedUser.clientLobRoles);
          const currentLocation = window.location.href.split('/').pop();

          if (clientNames.length === 0 && currentLocation !== "Unauthorized") {
            window.location.href = "/Unauthorized";
            localStorage.setItem("insufficientRole", true)
            return;
          } else {
            localStorage.setItem("insufficientRole", false)

          }

          // to get CurrentUser
          const isIntialLogin = !localStorage.getItem("wasLoggedInBefore");
          const url = isIntialLogin
            ? "/MRRUser/CurrentUser?isLogin=true"
            : "/MRRUser/CurrentUser";

          axios.get(url)
            .then((response) => {
              this.props.setCurrentUser(response.data);
              localStorage.setItem("userID", response.data.userID);
              // Mark that initial login is complete
              localStorage.setItem("wasLoggedInBefore", "true");
            });

            sessionStorage.setItem('refresh_token', tkns.refreshToken);

          // Schedule proactive renewal based on *current* tokens
          if (tkns) this.scheduleProactiveRenew(tkns, RENEW_BUFFER_SEC);

          this.setState({ hydrated: true });
          // to get client and environment
          axios.get('/session/portalurl')
            .then((response) => {
              var url = response.data;
              console.log("session/portalurl - response.data"); console.log(response.data);
              var startIdx = response.data.indexOf('://', 0) + 3;
              var endIdx = response.data.indexOf('-', 0)
              var client = endIdx !== -1 ? url.substr(startIdx, (endIdx - startIdx)).toLowerCase() : "dev";
              var clientLabel = client === 'qamrr' ? 'qa' : client;
              localStorage.Client = clientLabel;
              sessionStorage.setItem('Client', clientLabel);


              //environment
              var env = '';
              env = response.data.indexOf('prod', 0) > 0 ? 'prod' : (
                response.data.indexOf('int', 0) > 0 ? 'int' : (
                  response.data.indexOf('stage', 0) > 0 || response.data.indexOf('stg', 0) > 0 ? 'stg' : (response.data.indexOf('qa', 0) > 0 ? 'qa' : 'dev')
                )

              )
              localStorage.Environment = env;
            })

        });
    } catch (err) {
      switch (authAction) {
        case 'authorize':
          console.error('Authorization failed:', err);
          this.authHydrate('login', { login: 'redirect' });
          break;
        case 'login':
          console.error('Not able to login at the moment:', err);
          break;
        default:
          break;
      }
    }
  }
  
  componentDidMount() {
    // Handle redirect callback (code/state)
    const url = new URL(document.location.toString());
    const code = url.searchParams.get('code');
    const state = url.searchParams.get('state');
    const isRenewingPersisted = sessionStorage.getItem('auth:isRenewing') === '1';

    // If it is in the middle of renewal (after a redirect), do NOT kick off login.
    if (isRenewingPersisted) {
      console.log('[Mount] Skipping authHydrate because renewal is in progress');
      return;
    }

    // if (!this.state.isRenewing) {
      if (code && state) {
        this.authHydrate('authorize', { query: { code, state }, oauthThreshold: RENEW_BUFFER_SEC });
        // clean querystring afterwards
        window.history.replaceState({}, document.title, window.location.pathname);
      } else {
        this.authHydrate('login', { login: 'redirect', oauthThreshold: RENEW_BUFFER_SEC });
      }
    // }

    //  renew on tab focus if close to expiry
    document.addEventListener('visibilitychange', this._visibilityHandler);
  }
 
  componentWillUnmount() {
    this.clearRenewTimer();
    document.removeEventListener('visibilitychange', this._visibilityHandler);
  }


  render() {
    if (!this.state.hydrated) {
      return <Spinner />; // or a spinner
    }
    return (
      <>
        <Router history={browserHistory}>
          {Routes}
        </Router>
        <SessionTimeoutManager></SessionTimeoutManager>
      </>
    );
  }
}

export default connect(
  null,
  mapDispatchToProps
)(withAITracking(reactPlugin, App));
